var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isConfirmShown
      ? _c("div", { staticClass: "ConfirmPopup" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c("h5", { staticClass: "ConfirmPopup--heading d-flex" }, [
              _vm._v(_vm._s(_vm.confirmationModal.title))
            ]),
            _vm._v(" "),
            _c(
              "i",
              {
                staticClass: "material-icons ml-auto",
                style: { cursor: "pointer" },
                on: { click: _vm.close }
              },
              [_vm._v("\n                close\n            ")]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c("h4", { staticClass: "text-gray" }, [
              _vm._v(" " + _vm._s(_vm.confirmationModal.description) + " ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _c(
              "button",
              {
                staticClass:
                  "ConfirmPopup--button secondary-btn btn-center ml-auto",
                attrs: { type: "button" },
                on: { click: _vm.close }
              },
              [_vm._v("\n                No\n            ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ConfirmPopup--button danger-btn btn-center",
                attrs: { type: "button", disabled: _vm.isProgress },
                on: { click: _vm.callbackHandler }
              },
              [_vm._v("\n                Yes\n            ")]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ddc41d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ddc41d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/ConfirmPopup.vue
// module id = null
// module chunks = 